import apiClient from '../../../data/repositories/apiClient.js';
import { fixImageUrl } from '../../../utils/urlFixer.js';

export const uploadMultipleFiles = async (files) => {
    if (!files || files.length === 0) {
        throw new Error('No files provided');
    }
    
    console.log('Uploading multiple files:', files.length, 'files');
    files.forEach((file) => {
        console.log('File:', file.name, 'Size:', file.size, 'Type:', file.type);
    });
    
    const formData = new FormData();
    files.forEach((file) => {
        formData.append('files', file);
    });
    
    try {
        const data = await apiClient.upload('/uploads/array', formData);
        console.log('Upload array response:', data);
        console.log('Upload array response type:', typeof data);
        console.log('Upload array response keys:', Object.keys(data || {}));
        console.log('Upload array response JSON:', JSON.stringify(data, null, 2));
        
        // Handle different response formats
        let urls = [];
        
        // Try to extract URLs from various possible response formats
        if (Array.isArray(data)) {
            // Response is directly an array of URLs
            urls = data;
            console.log('Response is an array, using as URLs');
        } else if (data.fileUrls && Array.isArray(data.fileUrls)) {
            urls = data.fileUrls;
            console.log('Using data.fileUrls');
        } else if (data.urls && Array.isArray(data.urls)) {
            urls = data.urls;
            console.log('Using data.urls');
        } else if (data.data && Array.isArray(data.data)) {
            urls = data.data;
            console.log('Using data.data');
        } else if (data.gallery && Array.isArray(data.gallery)) {
            // Try data.gallery (for gallery uploads)
            urls = data.gallery;
            console.log('Using data.gallery');
        } else if (data.files && Array.isArray(data.files)) {
            // Try data.files
            urls = data.files;
            console.log('Using data.files');
        } else if (data.images && Array.isArray(data.images)) {
            // Try data.images
            urls = data.images;
            console.log('Using data.images');
        } else if (data.result && Array.isArray(data.result)) {
            // Try data.result
            urls = data.result;
            console.log('Using data.result');
        } else if (data.items && Array.isArray(data.items)) {
            // Try data.items
            urls = data.items;
            console.log('Using data.items');
        } else if (typeof data === 'string' && (data.startsWith('http') || data.startsWith('/'))) {
            // Response is a single URL string
            urls = [data];
            console.log('Response is a single URL string, wrapping as array');
        } else {
            console.error('Unexpected response format:', data);
            console.error('Trying alternative extraction methods...');
            
            // Try to extract URLs from object values
            const values = Object.values(data || {});
            const urlArrays = values.filter(v => Array.isArray(v) && v.length > 0 && typeof v[0] === 'string');
            if (urlArrays.length > 0) {
                urls = urlArrays[0];
                console.log('Found URL array in object values:', urls);
            }
            
            // Try to find single URL strings in object values
            if (urls.length === 0) {
                const urlStrings = values.filter(v => typeof v === 'string' && (v.startsWith('http') || v.startsWith('/')));
                if (urlStrings.length > 0) {
                    urls = urlStrings;
                    console.log('Found URL strings in object values:', urls);
                }
            }
            
            // Try more extraction methods
            if (urls.length === 0 && typeof data === 'string') {
                urls = [data];
                console.log('Response is a string, wrapping as array:', urls);
            } else if (urls.length === 0 && data.data && typeof data.data === 'string') {
                urls = [data.data];
                console.log('Response.data is a string, wrapping as array:', urls);
            }
        }
        
        if (!urls || urls.length === 0) {
            console.error('No URLs found after all attempts');
            console.error('Response structure:', data);
            console.error('Response JSON:', JSON.stringify(data, null, 2));
            throw new Error('Invalid response format from upload - no URLs found');
        }
        
        // Filter out non-string URLs and extract from objects
        urls = urls.map(url => {
            // If url is an object with fileUrl property, extract it
            if (typeof url === 'object' && url !== null && url.fileUrl) {
                console.log('Extracting fileUrl from object:', url.fileUrl);
                return url.fileUrl;
            }
            // If url is an object with url property, extract it
            if (typeof url === 'object' && url !== null && url.url) {
                console.log('Extracting url from object:', url.url);
                return url.url;
            }
            // If url is already a string, return it
            if (typeof url === 'string') {
                return url;
            }
            // Otherwise return null to filter out
            return null;
        }).filter(url => typeof url === 'string' && url.length > 0);
        
        if (urls.length === 0) {
            console.error('No valid string URLs found in response');
            console.error('Response structure:', data);
            console.error('Response JSON:', JSON.stringify(data, null, 2));
            console.error('All values in response:', Object.entries(data || {}).map(([k, v]) => `${k}: ${typeof v} = ${JSON.stringify(v).substring(0, 100)}`));
            throw new Error('No valid URLs in upload response');
        }
        
        console.log('Extracted URLs before fixing:', urls);
        
        // Fix URLs that point to old test servers
        const fixedUrls = urls.map(url => fixImageUrl(url));
        console.log('Fixed URLs:', fixedUrls);
        
        return fixedUrls;
    } catch (error) {
        console.error('Upload array error:', error);
        throw error;
    }
};


